import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import listMixin from '../listMixin';
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import { userItemsPerListMixin } from '@/utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['title'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicConsumersList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {
    selectedAccounts: {
      type: Array,
      required: false,
      default: undefined
    }
  },
  data: function () {
    return {
      lastSearch: '',
      isInitialSearch: false,
      disableFetchOnCreatedMixin: true,
      tableOptions: {
        ...defaultTableOptions
      },
      expanded: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'center'
        }, {
          value: 'icon',
          sortable: false,
          align: 'center'
        }, {
          text: this.$i18n_t('NiotaClassic.Consumers.detail.title'),
          value: 'title',
          align: 'start'
        }, {
          text: this.$i18n_t('NiotaClassic.Consumers.table.type'),
          sortable: true,
          value: 'type',
          align: 'start'
        }, {
          text: this.$i18n_t('Common.tenant'),
          sortable: true,
          value: 'accountName'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
          value: 'createdAt'
        }, ...(this.isIotHubManager ? [{
          align: 'end',
          sortable: false,
          value: 'actions',
          width: '78'
        }] : [])],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    selectedAccounts: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.updateAccountParams();
      this.fetchList(true);
    }, 500)
  },
  created() {
    defaultTableOptions.itemsPerPage = this.savedUserItemsPerList();
    const page = parseInt(this.$route.query.page, 10) || defaultTableOptions.page;
    const perPage = parseInt(this.$route.query.perPage, 10) || defaultTableOptions.itemsPerPage;
    const search = this.$route.query.search || '';
    if (search) {
      this.isInitialSearch = true;
      this.searchItem = search;
    }
    this.tableOptions.page = page;
    this.tableOptions.itemsPerPage = perPage;
  },
  methods: {
    updatePagination(e) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            page: e.page || defaultTableOptions.page
          },
          ...{
            perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
          }
        }
      }).catch(error => {
        console.error(error);
      });
    },
    updateAccountParams() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            accounts: this.getAccountIds(this.selectedAccounts).join(',') || undefined
          }
        }
      }).catch(error => {
        console.error(error);
      });
    },
    updateSearchParams(searchTerm) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          ...{
            search: searchTerm || undefined
          } // set to undefined on empty string to remove from query params
        }
      }).catch(error => {
        console.error(error);
      });
    },
    fetchList() {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const trimmedSearch = (this.searchItem || '').trim();
      if (this.lastSearch !== trimmedSearch) {
        this.lastSearch = trimmedSearch;
        if (!this.isInitialSearch) {
          this.tableOptions = {
            ...this.tableOptions,
            page: 1
          };
        }
        this.isInitialSearch = false;
      }
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = Math.max(1, page || 1);
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      let promise = undefined;
      if (trimmedSearch) {
        this.updateSearchParams(trimmedSearch);
        if (!this.selectedAccounts.length) {
          promise = NiotaClassicApiService.consumersFind(trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.consumersFindByAccount(this.getAccountIds(this.selectedAccounts), trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      } else {
        this.updateSearchParams('');
        if (!this.selectedAccounts.length) {
          promise = NiotaClassicApiService.consumersFetch(usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.consumersFetchByAccount(this.getAccountIds(this.selectedAccounts), usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      }
      promise.then(res => {
        if (res.data.consumer) {
          this.list = res.data.consumer;
        } else {
          this.list = res.data.consumers;
        }
        this.serverItemsLength = res.pagination.itemCount;
      }).catch(error => {
        console.error('Error fetching consumers', error);
      }).finally(() => {
        this.isFetching = false;
      });
    },
    deletePromise() {
      return NiotaClassicApiService.consumersDelete(this.selectedItem);
    },
    handleClickConsumer(item) {
      this.$router.push(`/niota-classic/consumers/${item.id}`);
    },
    getAccountIds(accounts) {
      let ids = [];
      accounts.forEach(account => {
        ids.push(account.id);
      });
      return ids;
    }
  }
};